/** Pendant zu `Services/API/ApiGruppenkennzeichenService.cs`. */

import type { ChinaAppSysGruppenkennzeichen } from '@/types/entities';
import type { EntityTypes } from '@/types/enums';

import { buildAppPath, createCrudApi, requestOrFallback, type CrudApi } from '../apiBase';
import { apiClient } from '../httpClient';

const ENDPOINT = 'gruppenkennzeichen';

export const gruppenkennzeichenApi: CrudApi<ChinaAppSysGruppenkennzeichen> & {
  getByField(entity: EntityTypes, fieldName: string): Promise<ChinaAppSysGruppenkennzeichen[]>;
  getFieldNames(entity: EntityTypes): Promise<string[]>;
} = {
  ...createCrudApi<ChinaAppSysGruppenkennzeichen>(ENDPOINT),

  // Die Entität steht als Zahl im Pfad — `(int)entity` im Altclient.
  getByField: (entity, fieldName) =>
    requestOrFallback(
      () =>
        apiClient.get<ChinaAppSysGruppenkennzeichen[]>(
          `${buildAppPath(ENDPOINT)}/${entity}/field/${fieldName}`,
        ),
      [],
    ),

  getFieldNames: (entity) =>
    requestOrFallback(
      () => apiClient.get<string[]>(`${buildAppPath(ENDPOINT)}/${entity}/fields`),
      [],
    ),
};
